import { 
    SICKNESS_KIND_GET_REQUEST, SICKNESS_KIND_GET_SUCCESS, SICKNESS_KIND_GET_ERROR, 
    SICKNESS_KIND_GET_BY_KEY_REQUEST, SICKNESS_KIND_GET_BY_KEY_SUCCESS, SICKNESS_KIND_GET_BY_KEY_ERROR, 
    SICKNESS_KIND_ADD_REQUEST, SICKNESS_KIND_ADD_SUCCESS, SICKNESS_KIND_ADD_ERROR, 
    SICKNESS_KIND_EDIT_REQUEST, SICKNESS_KIND_EDIT_SUCCESS, SICKNESS_KIND_EDIT_ERROR, 
    SICKNESS_KIND_DELETE_REQUEST, SICKNESS_KIND_DELETE_SUCCESS, SICKNESS_KIND_DELETE_ERROR
} from "../constants/sicknessKindConstants";

const initialState = {
    sicknessKinds: [],
    sicknessKind: {},
    loading: false,
    success: null,
    error: null,
    sicknessKindRequestedCount: 0,
};

export const sicknessKindReducer = (state = initialState, action) => {
    switch (action.type)     {
        case SICKNESS_KIND_GET_REQUEST:
            return {
                ...state,
                sicknessKindRequestedCount: ++state.sicknessKindRequestedCount,
                loading: true,
            };
        case SICKNESS_KIND_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                sicknessKinds: action.payload,
                success: true,
            };
        case SICKNESS_KIND_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case SICKNESS_KIND_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SICKNESS_KIND_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                sicknessKind: action.payload,
                success: true,
            };
        case SICKNESS_KIND_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case SICKNESS_KIND_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SICKNESS_KIND_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case SICKNESS_KIND_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case SICKNESS_KIND_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SICKNESS_KIND_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case SICKNESS_KIND_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case SICKNESS_KIND_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SICKNESS_KIND_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case SICKNESS_KIND_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
